(function(){
  // Wait for the DOM content to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    
      var active_variant = 0; // Variable to store the active variant
      var active_zone = ''; // Variable to store the active zone
      var active_size = ''; // Variable to store the active size
      var active_price = '';
      var active_compare_price = '';
      var discount = 0;
    
      // Select relevant elements from the DOM
      var sizeBtnTrigger = document.querySelector('.pbi-size-btn-trigger');
      var sizeBtn = document.querySelector('.pbi-size-btn');
      var customSelectorLabels = document.querySelectorAll('.pbi-custom-selector-box > label');
    
      var selectSizeDropdown = document.querySelector('#select_size_active');
      var selectSizeButtons = document.querySelectorAll('#select_size_list button');
    
      var selectVariant = document.getElementById('select_variant');
    
      var priceBox = document.querySelector('.product-form.template-custom-product .product-form__buy-buttons .price');
      var comparePriceBox = document.querySelector('.product-form.template-custom-product .product-form__buy-buttons .custom-price-compare');
      var saleBadge = document.querySelector('.product-form.template-custom-product .product-form__buy-buttons .custom-price-badge');

      var addToCart = document.querySelector('#AddToCart');      

      // Function to set the active variant based on selected zone and size
      function setActiveVariant() {
          // Check if all necessary elements are available
          if (selectVariant && active_zone && active_size) {
            
              var targetValue = active_zone + ' / ' + active_size;
              var options = selectVariant.options;
            
              var matchingOption = null;
              
              // Iterate over options to find the matching one
              for (var i = 0; i < options.length; i++) {
                  if (options[i].dataset.value == targetValue) {
                      matchingOption = options[i];
                      break;
                  }
              }
                        
              if (matchingOption !== null) {
                  // Select the matching option
                  matchingOption.selected = true;
                  active_price = matchingOption.dataset.price;
                  active_compare_price = matchingOption.dataset.compare_price;
                
              } else {
                  // If no matching option found, select the first option
                  selectVariant.selectedIndex = 0;
                  active_price = selectVariant.options[ 0 ].dataset.price;
                  active_compare_price = selectVariant.options[ 0 ].dataset.compare_price;
              }
            
              // Set the value of a hidden input field
              document.querySelector('.product-form.template-custom-product .product-form__buy-buttons [name="id"]').value = selectVariant.value;

              // Update displayed price
              var span = priceBox.querySelector('span');
              var cloneSpan = span.cloneNode(true);
              priceBox.innerHTML = active_price;
            
              // Append the cloned visually hidden span element to the price element
              priceBox.insertBefore(cloneSpan, priceBox.firstChild);

              // Show price
              priceBox.style.display = 'block';

              // Enable Add to Cart button
              addToCart.disabled = false;
            
              if ( active_compare_price ) {
                
                var active_price_num = parseFloat( active_price.replace(/[^0-9.]/g, "") );
                var active_compare_price_num = parseFloat( active_compare_price.replace(/[^0-9.]/g, "") );
                
                // Show/hide original price
                if ( active_price_num < active_compare_price_num ) {                
                  
                  comparePriceBox.innerHTML = active_compare_price;
                  comparePriceBox.style.display = 'block';

                  // Calculate discount
                  discount = ( ( active_compare_price_num - active_price_num ) * 100 ) / active_compare_price_num;
                  discount = discount.toFixed(2);

                  if ( saleBadge ) {
                    // Show/hide discount badge
                    if ( discount ) {
                      saleBadge.innerHTML = discount + '% off';
                      saleBadge.style.display = 'flex';
                    } else {
                      saleBadge.innerHTML = '';
                      saleBadge.style.display = '';
                    }      
                  }
           
                  
                } else {
                  comparePriceBox.innerHTML = '';
                  comparePriceBox.style.display = '';
                  if ( saleBadge ) {
                    saleBadge.style.display = '';
                  }
                }
                
              } else {
                comparePriceBox.innerHTML = '';
                comparePriceBox.style.display = '';
                if ( saleBadge ) {
                  saleBadge.style.display = '';
                }
              }

          } else {
              priceBox.style.display = '';
            
              comparePriceBox.innerHTML = '';
              comparePriceBox.style.display = '';

              if ( saleBadge ) {
                saleBadge.style.display = '';
              }
          }
      }

      // Function to show/hide variants based on the selected label
      function showHideVariants(label) {
        
        selectSizeButtons.forEach( (button) => {
            button.disabled = true;
        });

        label.querySelectorAll('ul li').forEach(function(zone) {

            selectSizeButtons.forEach( (button) => {
                if (button.value && button.value.indexOf(zone.innerText) === 0) {
                    button.disabled = false;
                }
            });
          
        });
        
      }
    
      // Event listener for triggering size button click
      sizeBtnTrigger.addEventListener('click', function() {
          if ( sizeBtn ) {
            sizeBtn.click(); // Simulate click on size button
          }
      });
    
      // Function to remove 'active' class from all labels
      function removeActiveClass() {
          customSelectorLabels.forEach(function(label) {
              label.classList.remove('active'); // Remove 'active' class
          });
      }
  
      // Function to set the first label as active
      function setFirstLabelActive() {
          if (customSelectorLabels.length > 0) {
              customSelectorLabels[0].classList.add('active'); // Add 'active' class to the first label
          }
          
      }

      // Event listener for label clicks
      customSelectorLabels.forEach(function(label) {
          label.addEventListener('click', function() {
              removeActiveClass(); // Remove 'active' class from all labels
              this.classList.add('active'); // Add 'active' class to the clicked label            
            
              showHideVariants(label); // Show/hide variants based on the clicked label

              // Reset size if zone has changed
              //if ( active_zone != this.dataset.value ) {
                //active_size = ''; // Reset selected size
                //selectSizeDropdown.classList.remove('open');  // Hide dropdown if it's open              
                //selectSizeDropdown.value = '';
                //selectSizeDropdown.innerHTML = selectSizeDropdown.dataset.label;
                //addToCart.disabled = true;
              //}

              // Automatically select the first available size when zone changes (Cart Critique Customization)
              if ( active_zone != this.dataset.value ) {
                active_zone = this.dataset.value; // Update zone first
                showHideVariants(this); // Update which buttons are enabled [cite: 31]

                // Find the first button that isn't disabled for this zone
                var firstAvailableButton = Array.from(selectSizeButtons).find(btn => !btn.disabled);

                if (firstAvailableButton) {
                    active_size = firstAvailableButton.value;
                    selectSizeDropdown.value = firstAvailableButton.value;
                    selectSizeDropdown.innerHTML = firstAvailableButton.value;
                    selectSizeDropdown.classList.remove('open');
                }
                
                // This will update the price and enable the button automatically 
                setActiveVariant(); 
              } // End of Cart Critique Customization
            
              active_zone = this.dataset.value; // Update active zone
              setActiveVariant(); // Update active variant
              
          });
      });
  
      // Listen for click events on the Size dropdown
      selectSizeDropdown.addEventListener('click', function() {
          this.classList.toggle('open');
      });

      // Listen for click events on the Size dropdown buttons
      selectSizeButtons.forEach( (button) => {
          button.addEventListener('click', function() {                        
              selectSizeDropdown.classList.remove('open');
              selectSizeDropdown.value = this.value;
              selectSizeDropdown.innerHTML = this.value;

              active_size = this.value;
              setActiveVariant();
          });
      });
        
      // Set the first label as active when the page loads
      //setFirstLabelActive();
  
      // Initialize active_zone and active_size based on initial values
      //active_zone = customSelectorLabels[0].dataset.value;
      //active_size = '';
        
      //showHideVariants(customSelectorLabels[0]); // Show/hide variants based on initial label

      //addToCart.disabled = true;

// Set the first label (Single Zone) and Twin XL as active (Cart Critique Customization)

// 1. Find the variant option that matches the target SKU
      var targetSku = "PSMT-X-M02";
      var targetOption = Array.from(selectVariant.options).find(opt => opt.dataset.sku === targetSku);

      if (targetOption) {
          // 2. Extract the size part from the full variant title (strips the Zone prefix)
          var fullTitle = targetOption.dataset.value; // e.g., "Single Zone / Twin XL (Half King) - 38\" x 80\""
          var sizeLabel = fullTitle.split(' / ')[1]; 
          
          // 3. Set standard active classes
          setFirstLabelActive();
          active_zone = customSelectorLabels[0].dataset.value; 
          active_size = sizeLabel;

          // 4. Update the dropdown UI
          selectSizeDropdown.value = sizeLabel;
          selectSizeDropdown.innerHTML = sizeLabel;

          // 5. Filter list and update price/Add to Cart status
          showHideVariants(customSelectorLabels[0]);
          setActiveVariant();
      } else {
          // Fallback if SKU isn't found
          setFirstLabelActive();
          active_zone = customSelectorLabels[0].dataset.value;
          showHideVariants(customSelectorLabels[0]);
      }

  });
  // End of Cart Critique Customization

// Set the second label (Dual Zone) and King as active (Cart Critique Customization)
/*
      var targetSku = "PSMT-K-M05";
      var targetOption = null;

      // Find the option matching the SKU
      if (selectVariant) {
          for (var i = 0; i < selectVariant.options.length; i++) {
              if (selectVariant.options[i].dataset.sku === targetSku) {
                  targetOption = selectVariant.options[i];
                  break;
              }
          }
      }

      if (targetOption && targetOption.dataset.value) {
          var fullTitle = targetOption.dataset.value; 
          var parts = fullTitle.split(' / ');
          var zoneLabel = parts[0];
          var sizeLabel = parts[1];

          // 1. Highlight the correct Zone (Dual Zone)
          removeActiveClass();
          customSelectorLabels.forEach(function(label) {
              if (label.dataset.value === zoneLabel) {
                  label.classList.add('active');
                  active_zone = zoneLabel;
                  showHideVariants(label);
              }
          });

          // 2. Sync the Dropdown UI
          active_size = sizeLabel;
          selectSizeDropdown.value = sizeLabel;
          selectSizeDropdown.innerHTML = sizeLabel;

          // 3. Update Price and Enable Button
          setActiveVariant();
      } else {
          // Fallback: If SKU isn't found, default to standard load
          setFirstLabelActive();
          if (customSelectorLabels[0]) {
              active_zone = customSelectorLabels[0].dataset.value;
              showHideVariants(customSelectorLabels[0]);
          }
          addToCart.disabled = true;
      }
  });
  */
  // End of Cart Critique Customization
  
})();